import { Link } from "react-router-dom";
import { Instagram, Youtube, Star, MapPin, Phone } from "lucide-react";
import { business, fullAddress } from "@/config/business";
import { navLinks } from "@/config/site";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-[hsl(var(--ink))] text-white" data-testid="footer">
    <div className="container-wide grid gap-12 py-16 md:grid-cols-[1.5fr_1fr_1fr]">
      <div>
        <p className="font-display text-2xl font-extrabold uppercase">Mobile <span className="accent-text">Specialist</span></p>
        <p className="mt-4 max-w-xs text-sm text-white/60">{fullAddress}</p>
        <div className="mt-4 flex items-center gap-2 text-sm text-white/80">
          <Star className="h-4 w-4 fill-[hsl(var(--accent))] text-[hsl(var(--accent))]" />
          {business.googleRating}/5 on Google · {business.googleReviewCount} Reviews
        </div>
        <div className="mt-6 flex gap-3">
          <a href={business.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-white/20 p-2.5 transition-colors hover:bg-white hover:text-[hsl(var(--ink))]"><Instagram className="h-5 w-5" /></a>
          <a href={business.youtubeUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="rounded-full border border-white/20 p-2.5 transition-colors hover:bg-white hover:text-[hsl(var(--ink))]"><Youtube className="h-5 w-5" /></a>
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-white/40">Explore</p>
        <ul className="mt-4 space-y-2.5">
          {navLinks.map((l) => (
            <li key={l.label}><Link to={l.to} className="text-sm text-white/70 transition-colors hover:text-white">{l.label}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-white/40">Visit & Contact</p>
        <ul className="mt-4 space-y-3 text-sm text-white/70">
          <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0" /> Sector 3, Rohini, Delhi - 110085</li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> <a href={`tel:${business.phone}`} className="hover:text-white">{business.phoneDisplay}</a></li>
          <li>{business.hoursSummary}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-wide flex flex-col items-center justify-between gap-2 py-5 text-xs text-white/40 sm:flex-row">
        <p>© {new Date().getFullYear()} Mobile Specialist, Rohini. All rights reserved.</p>
        <p>Buy • Sell • Repair — New & Pre-Owned Smartphones</p>
      </div>
    </div>
  </footer>
);
